// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__NljII","bg":"styles_bg__DOX+q"};